export const adminQueryKeys = {
  all: ["admin"] as const,
  session: ["admin", "session"] as const,
  dashboard: ["admin", "dashboard", "summary"] as const,
  audit: ["admin", "audit"] as const,
  catalogProducts: ["admin", "catalog", "products"] as const,
  catalogProduct: (productId: string | undefined) => ["admin", "catalog", "product", productId] as const,
  catalogCategories: ["admin", "catalog", "categories", "active"] as const,
  catalogCategoriesAll: ["admin", "catalog", "categories", "all"] as const,
  catalogFiles: (productId: string | undefined) => ["admin", "catalog", "files", productId] as const,
  orders: ["admin", "orders"] as const,
  order: (orderId: string | null) => ["admin", "order", orderId] as const,
  customers: ["admin", "customers"] as const,
  customer: (userId: string | null) => ["admin", "customer", userId] as const,
  subscriptions: ["admin", "subscriptions"] as const,
  coupons: ["admin", "coupons"] as const,
  orderBumps: ["admin", "order-bumps"] as const,
  orderBumpProducts: ["admin", "order-bumps", "products", "eligible"] as const,
  orderBumpTriggerProducts: ["admin", "order-bumps", "products", "triggers"] as const,
  orderBumpCategories: ["admin", "order-bumps", "categories"] as const,
  upsells: ["admin", "upsells"] as const,
  upsellProducts: ["admin", "upsells", "products"] as const,
  preSells: ["admin", "pre-sells"] as const,
  preSellSettings: ["admin", "pre-sell-settings"] as const,
  crossSells: ["admin", "cross-sells"] as const,
  content: (contentType: string) => ["admin", "content", contentType] as const,
  integrationsStatus: ["admin", "integrations", "status"] as const,
  emailDeliveries: ["admin", "integrations", "deliveries"] as const,
  team: ["admin", "team"] as const,
  webhooks: ["admin", "webhooks"] as const,
  webhookDeliveries: (webhookId: string | null) => ["admin", "webhooks", webhookId, "deliveries"] as const,
  checkoutStudio: {
    root: ["admin", "checkout-studio"] as const,
    draft: ["admin", "checkout-studio", "draft"] as const,
    versions: ["admin", "checkout-studio", "versions"] as const,
    preview: ["admin", "checkout-studio", "preview"] as const,
  },
  homeStudio: {
    root: ["admin", "home-studio"] as const,
    draft: ["admin", "home-studio", "draft"] as const,
    versions: ["admin", "home-studio", "versions"] as const,
    preview: ["admin", "home-studio", "preview"] as const,
    assets: ["admin", "home-studio", "assets"] as const,
  },
};
